"use strict";

exports.__esModule = true;
exports.defaultLocale = exports.default = void 0;
var constants = _interopRequireWildcard(require("../constants"));
var _constants$BRAND_MAGN;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var defaultLocale = exports.defaultLocale = {
  locale: 'en-GB'
};
var _default = exports.default = (_constants$BRAND_MAGN = {}, _constants$BRAND_MAGN[constants.BRAND_MAGNET] = {
  locale: 'en-GB'
}, _constants$BRAND_MAGN[constants.BRAND_MAGNETTRADE] = {
  locale: 'en-GB'
}, _constants$BRAND_MAGN[constants.BRAND_HTHGO] = {
  locale: 'da-DK'
}, _constants$BRAND_MAGN[constants.BRAND_HTHDK] = {
  locale: 'da-DK'
}, _constants$BRAND_MAGN[constants.BRAND_HTHNO] = {
  locale: 'nb-NO'
}, _constants$BRAND_MAGN[constants.BRAND_HTHSE] = {
  locale: 'sv-SE'
}, _constants$BRAND_MAGN[constants.BRAND_HTHFI] = {
  locale: 'fi-FI'
}, _constants$BRAND_MAGN[constants.BRAND_HTHDE] = {
  locale: 'de'
}, _constants$BRAND_MAGN[constants.BRAND_KEITTIOMAAILMA] = {
  locale: 'fi-FI'
}, _constants$BRAND_MAGN[constants.BRAND_NOREMA] = {
  locale: 'nb-NO'
}, _constants$BRAND_MAGN[constants.BRAND_SIGDAL] = {
  locale: 'nb-NO'
}, _constants$BRAND_MAGN[constants.BRAND_MARBODAL] = {
  locale: 'sv-SE'
}, _constants$BRAND_MAGN[constants.BRAND_UNOFORM] = {
  locale: 'da-DK'
}, _constants$BRAND_MAGN[constants.BRAND_UNOFORMNO] = {
  locale: 'nb-NO'
}, _constants$BRAND_MAGN[constants.BRAND_UNOFORMSE] = {
  locale: 'sv-SE'
}, _constants$BRAND_MAGN[constants.BRAND_UNOFORMBE] = {
  locale: 'nl-BE'
}, _constants$BRAND_MAGN[constants.BRAND_INVITA] = {
  locale: 'da-DK'
}, _constants$BRAND_MAGN[constants.BRAND_NOVART] = {
  locale: 'fi-FI'
}, _constants$BRAND_MAGN);